export default "__VITE_ASSET__S59PlZxy__"